// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".error[data-v-64f8a9a5]{position:absolute;top:0;left:0;width:100%;height:100%;z-index:88888;opacity:.8;background:#000;box-shadow:0 0 5px 1px rgba(0,0,0,.8)}.error .info[data-v-64f8a9a5]{color:#ff4136;text-align:center;font-size:4rem;position:fixed;top:350px;right:0;left:0;margin:auto}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
